import { Component } from '@angular/core';

@Component({
  selector: 'ssg-pay-info',
  templateUrl: './pay-info.component.html',
  styleUrls: ['./pay-info.component.less']
})
export class PayInfoComponent {
  constructor() { }
}
